export const DISAPPROVED = 'DISAPPROVED'
export const INVALIDATED = 'INVALIDATED'
export const FINISHED = 'FINISHED'
export const WAITING_VALIDATION = 'WAITING_VALIDATION'
export const VALIDATED = 'VALIDATED'
export const VALIDATED_WITHOUT_MEDICAL_REQUEST = 'VALIDATED_WITHOUT_MEDICAL_REQUEST'
export const PENDING_AUTHORIZATION = 'PENDING_AUTHORIZATION'
